var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align"},[_c('div',[_c('AccountIcon',{staticClass:"d-inline mr-2",attrs:{"account":_vm.account}})],1),_c('div',[_c('span',[_vm._v(_vm._s(_vm.account.name))])])])}
var staticRenderFns = []

export { render, staticRenderFns }